import { formatDateID } from "@/lib/format";

interface DashboardGreetingProps {
  greeting: string;
}

export function DashboardGreeting({ greeting }: DashboardGreetingProps) {
  const now = new Date();
  return (
    <div className="flex flex-col gap-1">
      <h1 className="text-2xl font-medium text-ocean-900">{greeting}</h1>
      <p className="text-sm text-neutral-500">{formatDateID(now)}</p>
    </div>
  );
}
